import { render } from "./Initial.vue?vue&type=template&id=4d29bfd4&ts=true"
import script from "./Initial.vue?vue&type=script&lang=ts"
export * from "./Initial.vue?vue&type=script&lang=ts"

import "./Initial.vue?vue&type=style&index=0&id=4d29bfd4&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__